import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  text-align: left;
  flex-direction: column;
  line-height: 1.8rem;

  h2 {
    margin-bottom: 0.4rem;
  }

  border-radius: 16px;
  border: solid 0.1px ${({ theme }) => `rgb(${theme.component.accent})`};

  img {
    align-self: center;
  }

  .subtitle {
    font-size: 0.9rem;
    line-height: 1.2rem;
    margin-top: 0.5rem;
    font-weight: 300;
    text-align: center;
    strong {
      color: ${({ theme }) => `rgb(${theme.blue['500']})`};
    }
  }

  .title {
    text-align: center;
  }

  .items {
    font-size: 0.8rem;
    span {
      display: flex;
      items-align: center;
      align-items: center;
      gap: 0.5rem;
      margin-bottom: 0.5rem;
    }

    .icon {
      border: solid 0.1px ${({ theme }) => `rgb(${theme.component.accent})`};
      height: 36px;
      width: 36px;
      padding: 0.4rem;
      border-radius: 30%;
    }
  }

  width: 90%;
  padding: 1rem;
  margin: 1rem auto;

  @media only screen and (min-width: 700px) {
    width: 400px;
    margin: 2rem auto;
  }

  @media only screen and (min-width: 1090px) {
    margin: 2rem auto;
    width: 600px;
    border-radius: 16px;
    padding: 2rem 3rem;
  }

  .offer-container {
    text-align: center;
    padding: 2rem 0 0.5rem;

    a {
      color: #0c291b;
      background-color: #00ea84;
      text-align: center;
      text-transform: uppercase;
      border: 1px solid #e0e0e0;
      border-radius: 12px;
      padding: 0.75rem 2.5rem;
      font-weight: 700;
      transition: all 0.2s;
      width: 100%;
      display: block;
      border-color: rgba(29, 83, 57, 0.24);
    }
  }
`
